export default __webpack_public_path__ + "static/media/03_Marketing_Guidelines.1fd0f72a.pdf";